// extracted by mini-css-extract-plugin
export var icon = "_ad-3";
export var subtitle = "_ad-2";
export var title = "_ad-1";
export var value = "_ad-0";